import { Grid, Paper } from '@mui/material'
import React from 'react'
import { BackButton } from './BackButton'
import { SubmitButton } from './SubmitButton'

export interface Props {
  deleteButton?: React.ReactNode
  title?: React.ReactNode
  PaperComponent?: React.ComponentType<React.PropsWithChildren<{}>>
  backButtonProps?: Partial<React.ComponentProps<typeof BackButton>>
  submitButtonProps?: Partial<React.ComponentProps<typeof SubmitButton>>
}

/**
 * BasicFormLayout provides some basic structure. it wraps your content with a back/submit button and a paper
 *  it should only be used inside a Form component (or other formix wrapper)
 */
export const BasicFormLayout: React.FC<Props> = ({
  children,
  title,
  deleteButton,
  backButtonProps,
  submitButtonProps,
  PaperComponent = DefaultPaperComponent
}) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {/* Title  and buttons */}
        <Grid container justifyContent='space-between' spacing={1}>
          <Grid item>{title}</Grid>
          <Grid item>
            <Grid container justifyContent='flex-end' spacing={1}>
              <Grid item>
                <BackButton {...backButtonProps} />
              </Grid>
              {deleteButton}
              <Grid item>
                <SubmitButton {...submitButtonProps} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PaperComponent>{children}</PaperComponent>
      </Grid>
    </Grid>
  )
}

export default BasicFormLayout

export const DefaultPaperComponent: React.FC<{}> = ({ children }) => {
  return <Paper sx={{ p: 2 }}>{children}</Paper>
}

export const NoPaperComponent: React.FC<{}> = ({ children }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
